export const QUESTION = ["id", "name", "icon"];
